import { useHistory } from 'react-router-dom';

import { Button } from 'modules/v2/common/AtomicDesign/atoms';
import { getRouteBuyCredits } from 'modules/v2/routes/navigation';
import { usePrintCreditsBalance } from 'modules/v2/common/hooks/usePrintCreditsBalance';

import strings from '../../strings';
import { formatCredits } from '../../utils';

const CreditsBalanceWidget = ({ showBuyButton = false }) => {
  const history = useHistory();
  const { data, isLoading } = usePrintCreditsBalance();

  return (
    <div className="flex items-center justify-between gap-4 rounded-lg border border-neutral-200 bg-white px-4 py-3">
      <div>
        <div className="text-sm text-neutral-500">{strings.credits.balanceLabel}</div>
        <div className="text-xl font-semibold" data-testid="mod-credits-balance">
          {isLoading ? strings.common.loading : formatCredits(data?.balance)}{' '}
          {!isLoading && <span className="text-sm font-normal">{strings.credits.balanceUnit}</span>}
        </div>
      </div>
      {showBuyButton && (
        <Button color="outlined" size="sm" onClick={() => history.push(getRouteBuyCredits())}>
          {strings.credits.buyMore}
        </Button>
      )}
    </div>
  );
};

export default CreditsBalanceWidget;
